/**
 * Geteilter Vertrag fuer den Multi-Select-"Bezahlmethode"-Filter der Buchungsliste.
 *
 * Der Client verwendet diese Keys als Option-`value` (FilterDropdownSelectMultiple),
 * der Server (booking.filters.ts → findByPaymentMethod) mappt denselben Key auf eine
 * SQL-Bedingung. Client-Option-value === Server-Key ist der Vertrag.
 *
 * Labels sind bewusst NICHT hier: sie sind reine deutsche UI-Texte und leben im
 * Client (BookingListColumns.tsx). Legacy-Werte (z.B. gespeicherte Filter
 * 'BankTransfer'/'SepaDebit') sind hier absichtlich NICHT enthalten — der Server
 * behandelt unbekannte Keys ueber einen type-Fallback.
 */
export enum PaymentMethodFilterCategory {
    BankTransferManual = "BankTransferManual",
    BankTransferMollie = "BankTransferMollie",
    SepaDebitManual = "SepaDebitManual",
    SepaDebitMollie = "SepaDebitMollie",
    Cash = "Cash",
    Creditcard = "Creditcard",
    Paypal = "Paypal",
    Applepay = "Applepay",
    Googlepay = "Googlepay",
    OnlineOpen = "OnlineOpen",
}
